import React from 'react'
import styled from 'styled-components'

import { ProductLabelStatus } from '../../../graphql/search'
import { labelDesignItemValues } from '../../../lib/cart/item'
import { useLabelStatusForCartItemSku } from '../../../lib/cart/state/cart-items/cart-item-remove'
import { CartItemVirtualProduct } from '../../../lib/cart/state/types'
import LabelStatusIcon from '../../LabelStatusIcon'

const StyledLabelStatusIcon = styled(LabelStatusIcon)`
  margin-right: 5px;
`

const LabelInfoHeader = styled.span`
  display: flex;
  align-items: center;
  flex-direction: row;
  line-height: 0.7em;
`

const LabelInfoTitle = styled.span`
  font-size: 14px;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 2px;
`

const LabelInfoDetails = styled.span`
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  padding: 10px;
`

const LabelFields = styled.span`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
`

const LabelField = styled.span`
  flex-direction: row;
`

const LabelFieldTitle = styled.span`
  font-weight: 500;
`

const CartItemLabelInformation: React.FC<{
  sku: string
  labelItem?: CartItemVirtualProduct
}> = ({ sku, labelItem }) => {
  const result = useLabelStatusForCartItemSku(sku)
  if (result._tag === 'Left') {
    return null
  }
  const labelFeeValues = labelItem && labelDesignItemValues(labelItem)
  const isLabelPresent = result.data.labelStatus === ProductLabelStatus.Present
  return (
    <LabelInfoDetails>
      <LabelInfoHeader>
        <StyledLabelStatusIcon isLabelPresent={isLabelPresent} />
        <LabelInfoTitle>
          {isLabelPresent ? 'LABEL ON FILE' : 'LABEL REQUEST DETAILS'}
        </LabelInfoTitle>
      </LabelInfoHeader>
      {!isLabelPresent && labelFeeValues && (
        <LabelFields>
          {labelFeeValues.map(({ label, value }) => (
            <LabelField key={label}>
              <LabelFieldTitle>{label}: </LabelFieldTitle>
              <span>{value}</span>
            </LabelField>
          ))}
        </LabelFields>
      )}
    </LabelInfoDetails>
  )
}

export default CartItemLabelInformation
